import React, { type SyntheticEvent, useEffect, useState } from "react";
import { EuiDatePicker } from "@elastic/eui";
import { type DateValidator } from "anketa-core";
import moment, { type Moment } from "moment";
import { useAnketa } from "../context_provider";
import { DateQuestionEditorProps } from "src/questionnaires/types";

export const DateQuestionEditor = ({
  question,
  setValue,
  invalid,
}: DateQuestionEditorProps): JSX.Element => {
  const ctx = useAnketa();
  let locale = ctx.i18nContext.language;
  const dfAny = ctx.i18nContext.dateFormat as any;
  if (Object.prototype.hasOwnProperty.call(dfAny, "_abbr")) {
    locale = dfAny._abbr;
  }
  const validator = question.getValidator<DateValidator>();
  const min = validator?.min
    ? moment(question.getValidator<DateValidator>()?.min)
    : undefined;
  const max = validator?.max
    ? moment(question.getValidator<DateValidator>()?.max)
    : undefined;

  const [curDate, setCurDate] = useState<string>("");

  useEffect(() => {
    const val = question.fact.getMomentValue(ctx.i18nContext).isValid()
      ? question.fact
          .getMomentValue(ctx.i18nContext)
          .format(ctx.i18nContext.dateFormat.longDateFormat("L"))
      : undefined;
    setCurDate(val);
  }, [question, ctx]);
  return (
    <EuiDatePicker
      key={question.path}
      placeholder={ctx.i18nContext.render(question.placeholder)}
      isInvalid={invalid}
      readOnly={question.readonly}
      locale={locale}
      minDate={min}
      maxDate={max}
      value={curDate}
      onChange={(date: Moment, event?: SyntheticEvent<any, Event>) => {
        setCurDate(date.format(ctx.i18nContext.dateFormat.longDateFormat("L")));
        setValue(date.format(ctx.i18nContext.dateFormat.longDateFormat("L")));
      }}
      onBlur={() => {
        setValue(curDate, true);
      }}
    />
  );
};
